import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function CheckoutSuccess() {
  const { t } = useTranslation();

  useEffect(() => {
    // Try to close the tab — works because it was opened via window.open()
    window.close();
  }, []);

  // Fallback UI in case the browser blocks window.close()
  return (
    <div style={{
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'DM Sans', sans-serif",
      background: "linear-gradient(120deg, #5616ea 0%, #320661 100%)",
      color: "#fff",
      textAlign: "center",
      padding: "2rem",
    }}>
      <h1 style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>{t("checkout_success_title")}</h1>
      <p style={{ fontSize: "1.1rem", opacity: 0.9 }}>
        {t("checkout_success_text")}
      </p>
    </div>
  );
}
